import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldProps } from "@insite/mobius/TextField";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductAlertMessage from "@tCentro/Components/CENProductAlertMessage";
import CENProductDescription from "@tCentro/Components/CENProductDescription";
import ProductFinePrint from "@tCentro/Components/CENProductFinePrintText";
import ProductSpecialMessage from "@tCentro/Components/CENProductSpecialMessage";
import EllipsisVerticalIcon from "@tCentro/Icons/EllipsisVerticalIcon";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {}

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

const mapDispatchToProps = {};

type Props = ReturnType<typeof mapStateToProps> &
    HasProductContext &
    ResolveThunks<typeof mapDispatchToProps> &
    OwnProps;

export interface CENProductListActionsStyles {
    wrapper?: InjectableCss;
    quantityOrdered?: TextFieldProps;
    unitOfMeasureSelect?: SelectPresentationProps;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    price?: ProductPriceStyles;
}

export const actionsStyles: CENProductListActionsStyles = {
    wrapper: {
        css: css`
            display: flex;
            width: 100%;
            flex-direction: column;
        `,
    },
    unitOfMeasureSelect: {
        cssOverrides: {
            formField: css`
                margin-top: 0px;
                label {
                    font-size: ${TYPOGRAPHY.size.base};
                    line-height: 22px;
                    color: ${getProp("theme.typography.p.color")};
                }
            `,
            formInputWrapper: css`
                margin-bottom: 5px;
                margin-top: 5px !important;
            `,
        },
    },
    quantityBreakPricing: {
        viewLink: {
            css: css`
                margin: 8px 0;
            `,
        },
    },
};

const styles = actionsStyles;

const CENProductListActions: FC<Props> = ({ productContext }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <ProductUnitOfMeasureSelect extendedStyles={styles.unitOfMeasureSelect} />

            {productContext.product.properties.specialMessage && (
                <ProductSpecialMessage specialMessage={productContext.product.properties.specialMessage} />
            )}
            {productContext.product.properties.alertMessage && (
                <ProductAlertMessage alertMessage={productContext.product.properties.alertMessage} />
            )}

            {productContext.product.properties.finePrint && (
                <ProductFinePrint finePrint={productContext.product.properties.finePrint} />
            )}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withProductContext(CENProductListActions));
